import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FilterProperty, ListFilterService, StringDataBag, Option, FilterPropertyChanged } from '../common/list-filter/list-filter-service';
import { ListFilterComponent } from '../common/list-filter/list-filter.component';
import { ErrorService } from '../services/error.service';
import { EventBrokerService } from '../services/event-broker.service';
import { AdvancedSearchFilter, SearchResultItem } from '../services/models';
import { applySort, newId, SortDirection, SortItem } from '../services/utils';
import { SpSearchService } from './sp-search.service';



@Component({
  selector: 'app-sp-search',
  templateUrl: './sp-search.component.html'
})
export class SpSearchComponent implements OnInit, OnDestroy {

  allItems: SearchResultItem[] = [];
  allFilteredItems: SearchResultItem[] = [];
  allFilteredDocs: SearchResultItem[] = [];
  allFilteredRecords: SearchResultItem[] = [];
  activeTabId: number;
  query: string;
  completedQuery: string;
  sortedBy: 'Relevance' | 'Most Recent' = 'Relevance';
  sortOptions = ['Relevance', 'Most Recent'];
  isLoading = true;
  isfilter: boolean = false;

  channelProperty: FilterProperty = {
    Path: 'ChannelTitle', DisplayName: 'Channel', Type: 'string', IsVisibleOnMultiplePropertyFilter: true
  };
  taProperty: FilterProperty = {
    Path: 'HTAcommonTA', DisplayName: 'TA', Type: 'string', IsVisibleOnMultiplePropertyFilter: true
  };
  assetProperty: FilterProperty = {
    Path: 'HTAcommonAssets', DisplayName: 'Asset', Type: 'string', IsVisibleOnMultiplePropertyFilter: true
  };
  indicationProperty: FilterProperty = {
    Path: 'HTAcommonIndication', DisplayName: 'Indication', Type: 'string', IsVisibleOnMultiplePropertyFilter: true
  };

  properties: FilterProperty[] = [
    this.channelProperty, this.taProperty, this.assetProperty, this.indicationProperty];

  propertyMap = {
    ChannelTitle: this.channelProperty,
    Asset: this.assetProperty,
    TA: this.taProperty,
    Indication: this.indicationProperty
  }

  get resultCount(): number {
    switch (this.activeTabId) {
      case 1: return this.allFilteredItems.length;
      case 2: return this.allFilteredDocs.length;
      case 3: return this.allFilteredRecords.length;
      default: return 0;
    }
  }

  get itemType(): string {
    switch (this.activeTabId) {
      case 1: return 'items';
      case 2: return 'documents';
      case 3: return 'records';
      default: return '';
    }
  }

  private advancedSearchFilterHandler = (advancedSearchFilter: AdvancedSearchFilter) => {
    ListFilterService.clear(this.properties);
    this.addAdvancedSearchFilter(advancedSearchFilter);
    this.refilter();
  }

  private advancedSearchFilterSubscription: Subscription;

  @ViewChild('listFilter') listFilter: ListFilterComponent;

  constructor(
    private route: ActivatedRoute,
    private searchService: SpSearchService,
    private errorService: ErrorService,
    private eventBroker: EventBrokerService) {
    this.advancedSearchFilterSubscription = eventBroker.subscribe('AdvancedSearchFilterRequested', this.advancedSearchFilterHandler)
  }

  private refilter() {
    this.properties.forEach(property => {
      this.eventBroker.publish('FilterPropertyChanged', {
        sender: this,
        property: property
      } as FilterPropertyChanged)
    });
    this.listFilter.emitFilterChanged();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      console.log(params);
      try {
        this.query = params.query;
        this.isLoading = true;
        ListFilterService.clear(this.properties);
        const advancedSearchFilter = this.getAdvancedSeachFilter();
        if (advancedSearchFilter) {
          this.isfilter = true;
          this.addAdvancedSearchFilter(advancedSearchFilter);
        }
        this.allItems = await this.searchService.search(`*${params.query}*`);
        this.allFilteredItems = [...this.allItems];
        this.sort();
        this.completedQuery = this.query;
      }
      catch (error) {
        this.errorService.show('Failed to get search results', error);
        return;
      }
      this.isLoading = false;
    });
  }

  filterChanged(items: any[]) {
    /*if (this.isfilter) {
      this.allItems = items;
    }*/
    this.allFilteredItems = items;
    this.sort();
  }

  sort() {
    if (this.sortedBy === 'Relevance') this.sortByRelevance();
    else this.sortByMostRecent();
  }

  sortByRelevance() {
    this.sortedBy = 'Relevance';
    const sortItems: SortItem[] = [
      { propertyPath: 'Rank', direction: SortDirection.Descending },
      { propertyPath: 'ModifiedOWSDATE', direction: SortDirection.Descending }
    ];
    this.appySort(sortItems);
  }

  sortByMostRecent() {
    this.sortedBy = 'Most Recent';
    const sortItems: SortItem[] = [
      { propertyPath: 'ModifiedOWSDATE', direction: SortDirection.Descending },
      { propertyPath: 'Rank', direction: SortDirection.Descending }
    ];
    this.appySort(sortItems);
  }

  private appySort(sortItems: SortItem[]) {
    applySort(this.allFilteredItems, sortItems);
    this.allFilteredDocs = this.allFilteredItems.filter(x => x.IsDocument);
    this.allFilteredRecords = this.allFilteredItems.filter(x => !x.IsDocument);
  }

  private getAdvancedSeachFilter(): AdvancedSearchFilter {
    const advancedSearchFilterJson = localStorage.getItem("AdvancedSearchFilter");
    if (!advancedSearchFilterJson) return undefined;
    localStorage.removeItem("AdvancedSearchFilter");
    return JSON.parse(advancedSearchFilterJson) as AdvancedSearchFilter;
  }

  private addAdvancedSearchFilter(advancedSearchFilter?: AdvancedSearchFilter) {
    if (!advancedSearchFilter) return;
    for (const p in advancedSearchFilter) {
      const filterProperty = this.propertyMap[p] as FilterProperty;
      ListFilterService.ensureDataBag(filterProperty) as StringDataBag;
      const displayName = advancedSearchFilter[p] as string;
      if (displayName) {
        const value = displayName.toLowerCase();
        const option: Option = {
          DisplayName: displayName,
          Id: newId(),
          IsChecked: true,
          Value: value
        };
        ListFilterService.updateOption(filterProperty, option);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.advancedSearchFilterSubscription) this.advancedSearchFilterSubscription.unsubscribe();
  }
}
